import { onMounted, onUnmounted, ref } from 'vue';

export function useBreakpoint() {
    const isMobile = ref(false);
    const isTablet = ref(false);
    const isDesktop = ref(false);

    const updateBreakpoints = () => {
        const width = window.innerWidth;
        isMobile.value = width < 769;
        isTablet.value = width >= 769 && width < 1024;
        isDesktop.value = width >= 1024;
    };

    const handleResize = () => {
        window.requestAnimationFrame(updateBreakpoints);
    };

    onMounted(() => {
        updateBreakpoints();
        window.addEventListener(
            'resize',
            handleResize
        );
    });

    onUnmounted(() => {
        window.removeEventListener(
            'resize',
            handleResize
        );
    });

    return {
        isMobile,
        isTablet,
        isDesktop
    };
}
